<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form
        ref="companyForm"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="reset"
      >
        <div class="mb-4">
          <label>Business Logo <span class="optional">(Optional)</span></label>
          <image-uploader
            uploadText="Upload your business logo here."
            class="me-4"
            v-model="organization.logo"
            :showDeleteButton="true"
          />
        </div>

        <b-form-group class="mb-4">
          <label>Business Name <span class="red">*</span></label>
          <validation-provider
            name="business name"
            rules="required"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Business Name"
              v-model="organization.name"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-1">
          <label>Business Type <span class="optional">(Optional)</span></label>
          <validation-provider
            name="business type"
            rules=""
            v-slot="validationContext"
          >
            <b-form-select
              :state="getValidationState(validationContext)"
              class="form-select"
              v-model="bizTypeOption.value"
              :options="businessTypeOptions"
            ></b-form-select>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <b-form-group class="mb-4" v-if="bizTypeOption.others">
            <label class="biz-type-others-class px-2">For "Others," please specify your business type below.
            </label>
            <validation-provider name="business type others" rules="" v-slot="validationContext">
                <b-form-input :state="getValidationState(validationContext)" placeholder="Enter your Business Type" v-model="organization.businessType" trim></b-form-input>
                <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
            </validation-provider>
        </b-form-group>
        <b-form-group class="mt-4 mb-4">
          <label
            >Business Contact Number
            <span class="optional">(Optional)</span></label
          >
          <validation-provider
            name="business contact number"
            rules="ph-mobile"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Contact Number"
              v-model="organization.contact_number"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group class="mb-4" v-if="false">
          <label>Business Hours <span class="optional">(Optional)</span></label>
          <b-row>
            <b-col>
              <validation-provider
                name="business start hour"
                rules=""
                v-slot="validationContext"
              >
                <b-form-input
                  type="time"
                  :state="getValidationState(validationContext)"
                  v-model="organization.startHour"
                  trim
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                name="business end hour"
                rules=""
                v-slot="validationContext"
              >
                <b-form-input
                  type="time"
                  :state="getValidationState(validationContext)"
                  v-model="organization.endHour"
                  trim
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form-group>

        <div class="d-flex">
          <div class="w-50 d-flex">
            <div class="align-self-center cursor-pointer" @click="onBack">
              <feather
                type="chevron-left"
                class="icon-md text-primary"
              ></feather>
              Back to General
            </div>
          </div>
          <div class="w-50">
            <b-button
              class="w-100"
              type="submit"
              variant="primary"
              :disabled="isRegisterLoading"
            >
              <span
                v-if="isRegisterLoading"
                class="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Next
            </b-button>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { authComputed, authMethods } from "@/state/helpers";
const parsePhoneNumber = require("awesome-phonenumber").parsePhoneNumber;
import ImageUploader from "../../../components/ImageUploader.vue";

export default {
  props: ["value","isRegisterLoading"],
  components: {
    ImageUploader,
  },
  data() {
    return {
      logo: {},
      mobileNumber: null,
      organization: this.value,
      bizTypeOption: {
          others: false,
          value: null
      },
      businessTypeOptions: [
          { text: "Select Business Type", value: null },
          { text: "Retailers", value: "Retailers" },
          { text: "Grocery", value: "Grocery" },
          { text: "Restaurant", value: "Restaurant" },
          { text: "Café", value: "Café" },
          { text: "Fast Food Chain", value: "Fast Food Chain" },
          { text: "Online Food Seller", value: "Online Food Seller" },
          { text: "Services", value: "Services" },
          { text: "Others", value: "Others" },
      ],
    };
  },
  watch: {
    organization: {
      handler(val) {
        console.log("watch val", val);
        this.$emit("update", val);
      },
      deep: true,
    },
    mobileNumber: function (value) {
      if (value) {
        const pn = parsePhoneNumber(value, { regionCode: "PH" });
        if (pn.number.international) {
          this.organization.contact_number = pn.number.international.replace(
            /\s/g,
            ""
          );
        }
      }
    },
    'bizTypeOption.value' : {
        handler(value) {
            this.bizTypeOption.others = (value == 'Others');
            if(value != 'Others') this.organization.businessType = this.bizTypeOption.value
            else this.organization.businessType = '';
        },
        immediate: true,
    },
  },
  methods: {
    ...authMethods,
    onDrop(evt) {
      console.log(evt);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit: function () {
      this.$emit("submit");
    },
    onBack: function () {
      this.$emit("back");
    },
  },
  computed: {
    ...authComputed,
  },
};
</script>

<style scope>
.biz-type-others-class {
    color: #4B4B4B;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
}
</style>